import { useQuery } from '@apollo/client';

import { VehicleTypes } from '~/graphql';

import { VehicleTypesQuery } from '../vehicleTypes.queries';

export const useVehicleTypes = () => {
    return useQuery<VehicleTypes>(VehicleTypesQuery);
};
